import { Component, input } from '@angular/core';

@Component({
    selector: 'r1-compass-lib-instructions',
    imports: [],
    template: `
        <div class="instructions">
            <h3>{{ headerText() }}</h3>
            <p><ng-content /></p>
        </div>
    `,
    styles: `
        .instructions {
            h3 {
                margin: 0 0 10px 0;
            }

            p {
                margin: 0;
                padding-bottom: 10px;
            }
        }
    `,
})
export class InstructionsComponent {
    readonly headerText = input.required<string>();
}
